import router from '@/router'
import store from '@/store'
import { title as settingsTitle } from '@/settings'
import { checkSignedInStatus, setNotLoggedIn } from '@/utils/auth'

let loadedDynamicRoutes = false // 是否已加载动态路由
const whiteList = ['/login']
router.beforeEach(async (to, from, next) => {
  // 网页title跟随路由title
  document.title = settingsTitle + '-' + to.meta.title
  if (checkSignedInStatus()) {
    // 身份验证通过
    if (to.path !== '/login') { // 不在登录页面，正常进入相应页面
      if (loadedDynamicRoutes) {
        if(from.meta.title !== '登录页' && JSON.stringify(from.meta) !=="{}"){
          store.dispatch('topNavTag/addNavTag', to) // 顶部页面标签处理
        } 
        next()
      } else {
        try {
          // 获取用户信息
          await store.dispatch('user/getUserInfo')
          // 获取用户权限列表
          const authList = store.getters['user/getUserAuthList']
          // 获取用户有权限操作权限的路由
          const accessRoutes = await store.dispatch('routes/generateRoutes', authList)
          // 动态添加路由
          accessRoutes.forEach(route => {
            router.addRoute(route)
          })
          // 设为已加载动态路由
          loadedDynamicRoutes = true
          // 确保动态添加的路由已经被完全加载上去并替换浏览器路由使浏览器没有浏览历史可回退
          next({ ...to, replace: true })
        } catch (error) {
          // 设为非登录状态
          setNotLoggedIn()
          next('/login')
        }
      }
    } else { // 在登录页面
      next({ path: '/' })
    }
  } else { // 身份验证不过
    // 设为非登录状态
    setNotLoggedIn()
    if (whiteList.indexOf(to.path) !== -1) { // 处于不用登录页面
      next()
    } else {
      next('/login')
    }
  }
})
